import { inject, type InjectionKey } from "vue";

export const requireInjection = <T>(key: InjectionKey<T>, defaultValue?: T) => {
  const value = inject(key, defaultValue);

  if (typeof value === "undefined") {
    throw new TypeError(`DEV: Missing injection: ${key.toString()}`);
  }

  return value;
};
